var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "actividadDespacho" }, [
    _c(
      "div",
      {
        staticClass: "gridcard rounded-card",
        staticStyle: { "padding-top": "6px", "padding-right": "0px" },
        attrs: { align: "left" }
      },
      [
        _c(
          "v-layout",
          { attrs: { row: "", wrap: "" } },
          [
            _c(
              "v-flex",
              { attrs: { xs4: "", sm4: "", md4: "" } },
              [
                _c("v-text-field", {
                  staticStyle: { "padding-left": "15px" },
                  attrs: { label: "Buscar..." },
                  on: { input: _vm.searchDataActividadDes },
                  model: {
                    value: _vm.filtrobusquedaActividadDes,
                    callback: function($$v) {
                      _vm.filtrobusquedaActividadDes = $$v
                    },
                    expression: "filtrobusquedaActividadDes"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs8: "", sm8: "", md8: "" } },
              [
                _c(
                  "v-layout",
                  {
                    staticStyle: {
                      "padding-top": "20px",
                      "padding-right": "5px"
                    },
                    attrs: { "justify-end": "" }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          flat: "",
                          small: "",
                          "data-permiso": "Exportar",
                          color: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.exportar()
                          }
                        }
                      },
                      [
                        _c("v-icon", { staticClass: "icon" }, [
                          _vm._v("cloud_download")
                        ]),
                        _vm._v("  \n            "),
                        _c("span", { staticClass: "text" }, [
                          _vm._v("Exportar")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "grid-container" }, [
          _c("div", { staticClass: "fake-vertical-scrollbar" }),
          _c(
            "div",
            {
              ref: "gridContainerRef",
              staticClass: "Seriados",
              class: { ocultar_acciones: _vm.deshabilitar }
            },
            [
              _c("MantenedorGridSinCodigo", {
                attrs: {
                  "funcionalidad-id": _vm.funcionalidad,
                  "grid-options": _vm.gridOptions
                }
              })
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }